/**
 * SubnavCalendar.jsx
 * Created by michaelbray on 2/23/18.
 */

import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { DateRangePicker, DayPickerRangeController } from 'react-dates';
import moment from 'moment';
import { keys, values, includes } from 'lodash';

const propTypes = {
    handleMyDatetime: PropTypes.func.isRequired,
    autoFocus: PropTypes.bool,
    autoFocusEndDate: PropTypes.bool,
    initialStartDate: PropTypes.string,
    initialEndDate: PropTypes.string,
    disabled: PropTypes.bool,
    readOnly: PropTypes.bool,
    isCampground: PropTypes.bool,
    search: PropTypes.object,
    displayAvailability: PropTypes.object,
    renderAsSingleCalendar: PropTypes.bool,
    onClickFunction: PropTypes.func
};

const defaultProps = {
    isCampground: false
};

class SubnavCalendar extends React.Component {
    constructor(props) {
        super(props);

        let focusedInput = null;
        if (props.autoFocus) {
            focusedInput = 'startDate';
        }
        else if (props.autoFocusEndDate) {
            focusedInput = 'endDate';
        }

        this.state = {
            focusedInput,
            startDate: props.initialStartDate ? props.initialStartDate : props.search.checkin_time,
            endDate: props.initialEndDate ? props.initialEndDate : props.search.checkout_time
        };

        this.onDatesChange = this.onDatesChange.bind(this);
        this.onFocusChange = this.onFocusChange.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        const nextState = {};

        if (nextProps.initialStartDate) {
            if (this.state.startDate !== nextProps.initialStartDate) {
                nextState.startDate = nextProps.initialStartDate;
            }
        }

        if (nextProps.initialEndDate) {
            if (this.state.endDate !== nextProps.initialEndDate) {
                nextState.endDate = nextProps.initialEndDate;
            }
        }

        if (nextState) {
            this.setState(nextState);
        }
    }

    onDatesChange(startDate, endDate) {
        let start = startDate;
        let end = endDate;

        if (!this.props.readOnly && !this.props.disabled) {
            this.setState({
                startDate: start,
                endDate: end
            });

            if (startDate === 'Invalid Date') {
                start = null;
            }
            if (endDate === 'Invalid Date') {
                end = null;
            }

            if (start !== null && end !== null) {
                this.props.handleMyDatetime(start, true);
                this.props.handleMyDatetime(end, false);
            }
        }
    }

    onFocusChange(focusedInput) {
        this.setState({
            focusedInput
        });
    }

    // Note: this function is performance sensitive
    isDayBlocked(date) {
        if (this.props.isCampground) {
            return false;
        }

        if (this.props.displayAvailability.isValid && this.props.displayAvailability.dates) {
            const keyArray = [];
            this.props.displayAvailability.dates.forEach((item) => {
                if (values(item)[0] === 'Available') {
                    keyArray.push(keys(item)[0]);
                }
            });

            if (includes(keyArray, date.format('MM/DD/YYYY'))) {
                return false;
            }

            return true;
        }

        return false;
    }

    initialVisibleMonth() {
        let startDate = this.state.startDate;
        startDate = (startDate === '' || startDate === 'Invalid date' || startDate === null) ? moment() : moment(startDate);
        return moment(startDate, 'MM YYYY');
    }

    renderDay(day) {
        if (!this.isDayBlocked(day) && !day.isBefore(moment().startOf('day'))) {
            let stat = 'Unavailable';
            if (this.props.displayAvailability.dates !== [] && !this.props.isCampground) {
                this.props.displayAvailability.dates.forEach((item) => {
                    if (item[`${day.format('MM/DD/YYYY')}`]) {
                        stat = item[`${day.format('MM/DD/YYYY')}`];
                    }
                });
            }
            else {
                stat = 'Available';
            }

            switch (stat) {
                case 'Available':
                    return (
                        <div className="calendarDay rec-state-blue">
                            <p>{day.format('D')}</p>
                        </div>
                    );
                case 'Reservation':
                    return (
                        <div className="calendarDay rec-state-red">
                            <p>{day.format('D')}</p>
                        </div>
                    );
                case 'WalkUp':
                    return (
                        <div className="calendarDay rec-state-green">
                            <p>{day.format('D')}</p>
                        </div>
                    );
                case 'Administrative':
                    return (
                        <div className="calendarDay rec-state-green">
                            <p>{day.format('D')}</p>
                        </div>
                    );
                case 'Lottery':
                    return (
                        <div className="calendarDay rec-state-yellow">
                            <p>{day.format('D')}</p>
                        </div>
                    );
                default: // Unavailable
                    return (
                        <div className="calendarDay rec-state-gray">
                            <p>{day.format('D')}</p>
                        </div>
                    );
            }
        }
        else if (this.props.renderAsSingleCalendar === true) {
            return (
                <div className="calendarDay">
                    <span className="hovertext">Available</span>
                    <p>{day.format('D')}</p>
                    <span>
                        <a
                            href={day}
                            onClick={this.props.onClickFunction}>
                            A
                        </a>
                    </span>
                </div>
            );
        }

        return day.format('D');
    }

    renderIcon() {
        return (
            <span>
              <span className="DateRangePickerInput__arrow-icon">
                <svg viewBox="0 0 1000 1000"><path
                    d="M694.4 242.4l249.1 249.1c11 11 11 21 0 32L694.4 772.7c-5 5-10 7-16 7s-11-2-16-7c-11-11-11-21 0-32l210.1-210.1H67.1c-13 0-23-10-23-23s10-23 23-23h805.4L662.4 274.5c-21-21.1 11-53.1 32-32.1z" />
                </svg>
              </span>
            </span>
        );
    }

    render() {
        let { startDate, endDate } = this.state;

        startDate = (startDate === '' || startDate === 'Invalid date' || startDate === null) ? null : moment(startDate);
        endDate = (endDate === '' || endDate === 'Invalid date' || endDate === null) ? null : moment(endDate);

        if (this.props.renderAsSingleCalendar === true) {
            return (
                <DayPickerRangeController
                    onDatesChange={this.onDatesChange}
                    onFocusChange={this.onFocusChange}
                    focusedInput={this.state.focusedInput}
                    startDate={startDate}
                    endDate={endDate}
                    disabled={this.props.disabled}
                    readOnly={this.props.readOnly}
                    customArrowIcon={this.renderIcon()}
                    initialVisibleMonth={this.initialVisibleMonth.bind(this)}
                    startDateId="startDate"
                    endDateId="endDate"
                    startDatePlaceholderText="Check in"
                    endDatePlaceholderText="Check out"
                    screenReaderInputMessage="Check in date"
                    showDefaultInputIcon
                    isDayBlocked={this.isDayBlocked.bind(this)}
                    renderDay={this.renderDay.bind(this)} />
            );
        }

        return (
            <DateRangePicker
                onDatesChange={this.onDatesChange}
                onFocusChange={this.onFocusChange}
                focusedInput={this.state.focusedInput}
                startDate={startDate}
                endDate={endDate}
                disabled={this.props.disabled}
                readOnly={this.props.readOnly}
                customArrowIcon={this.renderIcon()}
                initialVisibleMonth={this.initialVisibleMonth.bind(this)}
                startDateId="startDate"
                endDateId="endDate"
                startDatePlaceholderText="Check in"
                endDatePlaceholderText="Check out"
                screenReaderInputMessage="Check in date"
                showDefaultInputIcon
                isDayBlocked={this.isDayBlocked.bind(this)}
                renderDay={this.renderDay.bind(this)} />
        );
    }
}


SubnavCalendar.defaultProps = defaultProps;
SubnavCalendar.propTypes = propTypes;

function select(state) {
    return {
        search: state.search
    };
}

export default connect(select)(SubnavCalendar);
